export const kStandardErrorClass = "standard-error"
export const kStandardErrorType = "Standard Error"
export const kStandardErrorPrefix = "ADRN"
export const kStandardErrorLabelKey = "DG.Inspector.graphPlottedStErr"
export const kStandardErrorUndoAddKey = "DG.Undo.graph.showPlottedStErr"
export const kStandardErrorRedoAddKey = "DG.Redo.graph.showPlottedStErr"
export const kStandardErrorUndoRemoveKey = "DG.Undo.graph.hidePlottedStErr"
export const kStandardErrorRedoRemoveKey = "DG.Redo.graph.hidePlottedStErr"
export const kStandardErrorValueTitleKey = "DG.PlottedAverageAdornment.stErrValueTitle"
export const kErrorBarStrokeColor = "#f6768e"
